import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addRespInst, removeRespInst } from "../../../../../../../../../../../redux/actions/resolucion";
import ResponsableInstalacionFormContainer from "./ResponsableInstalacionFormContainer";
import ResponsableInstalacionTable from "./ResponsableInstalacionTable";

const ResponsableInstalacionTableContainer = ({ }) => {
    const dispatch = useDispatch();
    const idDependenciaEmpleador = useSelector(
        (state) => state.resolucion.searchedEstablecimiento
    );
    const data = useSelector(
        (state) => state.resolucion.abmEquiposRadiologicos.respInst
    );


    const [openRespInstForm, setOpenRespInstForm] = useState(false);
    const [respInst, setRespInst] = useState(null);
    const handleRemoveRespInst = (row) => {
        dispatch(removeRespInst(row));
    };
    const handleOpenRespInstDialog = (rowData) => {
        setOpenRespInstForm(true);
        setRespInst(rowData);
    };

    const handleSubmitRespInst = (values) => {
        const body = {
            ...values,
            idDependenciaEmpleador: idDependenciaEmpleador,
        };
        dispatch(addRespInst(body, values.index));
        setOpenRespInstForm(false);
    };


    return (
        <>
            <ResponsableInstalacionTable
                handleDelete={handleRemoveRespInst}
                handleOpenForm={handleOpenRespInstDialog}
                data={data}
            />
            <ResponsableInstalacionFormContainer
                handleClose={() => setOpenRespInstForm(false)}
                open={openRespInstForm}
                handleSubmit={handleSubmitRespInst}
                values={respInst}
            />
        </>
    )
}

export default ResponsableInstalacionTableContainer;